import styled from "styled-components";
import { breakpoint } from "@utilities";

export const StyledFilterDesktop = styled.div<{
    $isSearchResultPage: boolean;
    width: number;
}>`
    background-color: #fff;
    margin: ${(p) => (p.width > 767 && p.$isSearchResultPage ? "0 30px 30px 0" : "unset")};
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        padding: 16px 16px;
        padding-bottom: 90px;
        height: 100%;
        .filterContainer {
            display: flex;
            flex-direction: column;
            flex: 1;
            overflow: hidden;
        }
        .filterRow {
            flex: 1;
            overflow-y: auto;
        }
        .buttonRow {
            flex-shrink: 0;
            display: block;
            .filterCol-258 {
                width: 100%;
                min-width: 0;
            }
            .applyFilterBtn {
                width: 100%;
                button {
                    padding: 16px;
                    font-size: 18px;
                    line-height: 28px;
                    height: 56px;
                }
            }
        }
    }

    @media (max-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
        padding: 16px 16px;
        margin-bottom: 15px;
    }

    @media (min-width: ${(p) => p.theme.breakPoints.breakIpadPro}) {
        padding-bottom: ${(p) => (p.$isSearchResultPage ? "22px" : "0")};
    }

    .searchResultPage {
        display: ${(p) => (p.$isSearchResultPage && p.width > 767 ? "block" : "none")} !important;

        .heading {
            display: flex;
            justify-content: space-between;
            padding: 12px 12px 0;
            align-items: flex-end;

            ${breakpoint.breakTablet`
                font-size: 19px;
                line-height: 22px;
            `}

            ${breakpoint.breakIpadPro`
                padding: 22px 22px 0;
            `}

            .resetBtn {
                font-size: 14px;
                font-weight: 700;
                line-height: 22px;
                /* Red like the Reset in filterGridActions — same action, so it
                   should not read as two different controls. */
                color: ${(p) => p.theme.colors.red};
            }
        }
    }

    .mobile {
        ${breakpoint.breakTablet`
            display: none !important;
        `}
    }

    .heading {
        font-size: 28px;
        font-weight: 700;
        line-height: 36px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .closeBtn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: ${(p) => p.theme.colors.gray_6};
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .filterContainer {
        display: flex;
        flex-direction: column;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            // flex: 1;
        }
    }

    .filterRow {
        display: block;
        flex-wrap: wrap;

        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            display: ${(p) => (p.$isSearchResultPage && p.width > 767 ? "block" : "flex")};
            padding: ${(p) => (p.$isSearchResultPage && p.width > 767 ? "0 12px" : "0")};
            flex: 1;
            // overflow-y: auto;
        }

        @media (min-width: ${(p) => p.theme.breakPoints.breakIpadPro}) {
            padding: ${(p) => (p.$isSearchResultPage && p.width > 767 ? "0 22px" : "0")};
        }

        .filterCol-338 {
            width: ${(p) =>
                p.width < 767 || p.$isSearchResultPage ? "auto !important" : "33.32%"};

            ${breakpoint.breakTablet`
                position: relative;
            `}

            .tagName {
                ${breakpoint.breakTablet`
                
                `}

                ${breakpoint.breakIpadPro`
                    max-width: 196px;
                `}

                ${breakpoint.breakLarge`
                    max-width: 260px;
                `}
            }

            .lengthOfTrip {
                display: flex;
                align-items: center;
                padding: 13px 0 13px 13px;
                border: 1px solid ${(p) => p.theme.colors.gray_5};

                @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                    border: none;
                    border-bottom: 1px solid ${(p) => p.theme.colors.gray_5};
                    padding: 22px 0;
                }

                input {
                    padding-left: 6px;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 26px;
                    max-width: 134px;

                    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                        padding-left: 16px;
                        flex: 1;
                        font-size: 16px;
                    }

                    &::placeholder {
                        color: ${(p) => p.theme.colors.gray_2};
                    }
                }

                .icon {
                    img {
                        width: 14px;

                        @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                            width: auto;
                        }
                    }
                }

                &.searchResult {
                    padding: 16px 14px 16px 0;
                    margin-bottom: 16px;
                }

                ${breakpoint.breakTablet`
                    &.searchResult {
                        padding: 13px;
                        margin-bottom: 16px;
                        border: none;
                        background-color: #F2F2F2;
                    }
                `}

                ${breakpoint.breakIpadPro`
                    padding: 28px 14px 28px 31px;

                    &.searchResult {
                        padding: 16px 14px 16px 31px;
                        margin-bottom: 16px;
                    }

                    .icon {
                        img {
                            width: auto;
                        }
                    }

                    input {
                        padding-left: 16px;
                        flex: 1;
                        font-size: 16px;
                    }
                `}
            }
        }

        .filterCol-514 {
            width: ${(p) =>
                p.width < 767 || p.$isSearchResultPage ? "auto !important" : "46.5063%"};
        }

        .filterCol-258 {
            width: ${(p) => (p.width < 767 || p.$isSearchResultPage ? "100%" : "33.33%")};
            ${breakpoint.breakTablet`
                position: relative;
            `}
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                flex: 1;
                min-width: 0;
            }

            .tagName {
                ${breakpoint.breakTablet`
                    max-width: 100px;
                `}

                ${breakpoint.breakIpadPro`
                    max-width: 131px;
                `}

                ${breakpoint.breakLarge`
                    max-width: 180px;
                `}
            }
        }
    }

    .buttonRow {
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            display: flex;
            flex-wrap: nowrap;
            gap: 1px;
            justify-content: space-between;
            .filterCol-258 {
                flex: 1;
                width: 33.33%;
            }
            .applyFilterBtn {
                flex: 1;
                width: 33.33%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            display: block;
            .filterCol-258 {
                width: 100%;
            }
            .applyFilterBtn {
                width: 100%;
            }
        }
    }

    .filterGrid {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 0;

        ${breakpoint.breakIpadPro`
            padding: 0;
        `}

        .filterGridRow {
            display: flex;
            gap: 8px;

            .filterItem {
                flex: 1;
                min-width: 0;
                position: relative;
            }
        }

        .filterGridActions {
            display: flex;
            align-items: center;
            gap: 16px;
            padding-top: 6px;

            button:first-child {
                margin-top: 0;
                white-space: nowrap;
                min-width: 140px;
            }
        }
    }

    .filterItem {
        &.searchResult {
            display: none !important;
        }

        .resetBtn {
            display: flex;
            justify-content: flex-end !important;
            align-items: center;

            img {
                margin-right: 12px;
            }

            .text {
                font-size: 16px;
                font-weight: 700;
                line-height: 26px;
            }
        }

        &.applyFilterBtn {
            button {
                margin-top: 0;
            }

            &.searchResult {
                padding-top: 16px;
                display: block !important;
            }
        }
    }
`;
